<template>
  <div class="simple-coming-soon">
    <div class="container">
      <div class="content">
        <!-- Simple Text -->
        <h1 class="title">Coming Soon</h1>
        <p class="subtitle">We're working on something amazing!</p>

        <!-- Simple Animation -->
        <div class="work-animation">
          <div class="worker">
            <div class="head"></div>
            <div class="body"></div>
            <div class="arm left-arm"></div>
            <div class="arm right-arm"></div>
          </div>
          <div class="tools">
            <div class="hammer"></div>
            <div class="wrench"></div>
          </div>
        </div>

        <!-- Simple Message -->
        <p class="message">Please check back later...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleComingSoon",
};
</script>

<style scoped>
.simple-coming-soon {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.container {
  text-align: center;
  padding: 2rem;
}

.title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
  animation: fadeIn 1s ease;
}

.subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  margin-bottom: 3rem;
  animation: fadeIn 1.5s ease;
}

.message {
  font-size: 1rem;
  color: #95a5a6;
  margin-top: 3rem;
  animation: fadeIn 2s ease;
}

/* Work Animation */
.work-animation {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.worker {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 100px;
}

.head {
  width: 30px;
  height: 30px;
  background: #3498db;
  border-radius: 50%;
  margin: 0 auto 5px;
  animation: headBob 2s ease-in-out infinite;
}

.body {
  width: 40px;
  height: 50px;
  background: #2980b9;
  margin: 0 auto;
  border-radius: 5px;
}

.arm {
  position: absolute;
  width: 20px;
  height: 8px;
  background: #2980b9;
  top: 40px;
}

.left-arm {
  left: -15px;
  transform-origin: right center;
  animation: hammerSwing 1.5s ease-in-out infinite;
}

.right-arm {
  right: -15px;
  transform-origin: left center;
  animation: wrenchTurn 2s ease-in-out infinite;
}

.tools {
  position: absolute;
  width: 100%;
  height: 100%;
}

.hammer {
  position: absolute;
  left: 30px;
  top: 40px;
  width: 40px;
  height: 8px;
  background: #e74c3c;
  border-radius: 2px;
  animation: hammerSwing 1.5s ease-in-out infinite;
}

.hammer:after {
  content: "";
  position: absolute;
  right: -5px;
  top: -8px;
  width: 10px;
  height: 24px;
  background: #c0392b;
  border-radius: 2px;
}

.wrench {
  position: absolute;
  right: 30px;
  top: 40px;
  width: 30px;
  height: 8px;
  background: #f39c12;
  border-radius: 2px;
  animation: wrenchTurn 2s ease-in-out infinite;
}

.wrench:after {
  content: "";
  position: absolute;
  left: -5px;
  top: -3px;
  width: 15px;
  height: 15px;
  background: #d35400;
  border-radius: 50%;
  clip-path: polygon(0% 0%, 100% 0%, 100% 70%, 70% 100%, 0% 100%);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes headBob {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes hammerSwing {
  0%,
  100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-30deg);
  }
}

@keyframes wrenchTurn {
  0%,
  100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }

  .work-animation {
    width: 150px;
    height: 150px;
  }

  .worker {
    width: 50px;
    height: 80px;
  }

  .head {
    width: 25px;
    height: 25px;
  }

  .body {
    width: 30px;
    height: 40px;
  }
}
</style>
